import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import { CredentialsContext } from '../components/CredentialsContext';

import SignUp from '../screens/SignUp';
import ActivationWithSMS from '../screens/ActivationWithSMS';
import TermsAndPoliciesScreen from '../screens/TermsAndPoliciesSreen';


const Stack = createStackNavigator();

const NewUserNavigator = () =>{
    return (
        <CredentialsContext.Consumer >
            {({storedCredentials})=> (
            <NavigationContainer  independent={true}>
                <Stack.Navigator>
                    <Stack.Screen name='Sign UP' key={5}>
                        {props=> <SignUp {...props} />}
                    </Stack.Screen>

                    <Stack.Screen name="Activation with SMS" key={6}>
                        {props=> <ActivationWithSMS {...props} />}
                    </Stack.Screen>

                    <Stack.Screen name="Terms and policies" key={7}>
                        {props=> <TermsAndPoliciesScreen {...props} />}
                    </Stack.Screen>
                    
                </Stack.Navigator>
            </NavigationContainer>    
            )}
        </CredentialsContext.Consumer>
    )

    // return (
    //     <CredentialsContext.Consumer >
    //         {({storedCredentials})=> (
    //         <NavigationContainer>
    //             <Stack.Navigator initialRouteName="Sign Up">
    //                 {storedCredentials
    //                 ?(
    //                     <>

    //                         <Stack.Screen name="Home" component={Home} />   
    //                         <Stack.Screen name="Room Modules" component={RoomModules} />
    //                         <Stack.Screen name='Fetch Room ' component={FetchRoom} />
    //                         <Stack.Screen name='Settings' component={Settings} />
    //                     </>
    //                 ):(
    //                     <>
    //                         <Stack.Screen name="Sign Up" component={SignUp} />
    //                         {/* <Stack.Screen name="Sign In" component={SignIn} /> */}
    //                         <Stack.Screen name="Activation with SMS" component={ActivationWithSMS} />
    //                     </>
    //                 )}
                    
    //             </Stack.Navigator>
    //         </NavigationContainer>    
    //         )}
    //     </CredentialsContext.Consumer>
    // )
};

export default NewUserNavigator;